import type { FC } from 'react';

import {
  IconButtonWithTooltip,
  Icons,
  TooltipPositions,
} from '@pp/core/src/components/controls/iconButton/IconButtonWithTooltip';

interface StreamControlPlainProps {
  active: boolean;
  onClick: () => void;
}

export const CrashStreamControlPlain: FC<StreamControlPlainProps> = ({ active, onClick }) => {
  return (
    <IconButtonWithTooltip
      data-testid="stream-control-button"
      icon={Icons.Video}
      active={active}
      onClick={onClick}
      tooltipOptions={{
        text: active ? 'TURN_ON_ANIMATION' : 'TURN_OFF_ANIMATION',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
